import { CustomChemicalRequest } from '../request-models/custom-chemical-request.model';
import { omitUndefined } from './wire-value-utils';

/**
 * The hub request body for creating or updating a custom chemical. Copies only the allowlisted fields and drops
 * the ones that are not set, so an update stays partial; `null` (clear the field) is kept.
 */
export function toCustomChemicalRequest(fields: CustomChemicalRequest): CustomChemicalRequest {
  return omitUndefined<CustomChemicalRequest>({
    name: fields.name,
    epaNumber: fields.epaNumber,
    manufacturer: fields.manufacturer,
    activeIngredient: fields.activeIngredient,
    signalWord: fields.signalWord,
    category: fields.category,
    formulation: fields.formulation,
    rei: fields.rei,
    phi: fields.phi,
    defaultRate: fields.defaultRate,
    targetPests: fields.targetPests,
    crops: fields.crops,
    notes: fields.notes,
  });
}
